import Vue, { VNode } from 'vue'
import prop from 'vue-strict-prop'
import { component, modifiers as m } from 'vue-tsx-support'

export default component({
	name: 'HeaderAddInput',
	props: {
		placeholder: prop(String).default('Add...'),
		value: prop(String).default(''),
	},
	data() {
		return {
			isExpanded: false,
		}
	},
	methods: {
		collapse(): void {
			this.isExpanded = false
		},
		expand(): void {
			this.isExpanded = true
			this.$emit('input', '')
			Vue.nextTick(() => {
				const el = this.$refs['input'] as HTMLInputElement
				el.value = this.value
				el.focus()
			})
		},
	},
	render(): VNode {
		const submit = () => {
			this.collapse()
			this.$emit('submit')
		}
		return this.isExpanded ?
			<div>
				<div class="ui inverted left icon input">
					<input
						class="prompt"
						placeholder={this.placeholder}
						ref="input"
						type="text"
						onBlur={this.collapse}
						onInput={e => this.$emit('input', e.target.value)}
						onKeyup={m.enter(submit)}
						/>
					<i class="add link icon"></i>
				</div>
			</div>
				:
			<div class="link" onClick={this.expand}>
				<i class="add icon" />
			</div>
	},
})
